import App from "./js/App.jsx";
import AppLogin from "./js/AppLogin.jsx";
import AppStatus from "./js/AppStatus.jsx";
import AppHeader from "./js/AppHeader.jsx";
import AppNavigation from "./js/AppNavigation.jsx";
import AppLogo from "./js/AppLogo.jsx";

export {
    App
};

const components = [
    AppLogin, AppStatus, AppHeader, AppLogo, AppNavigation
];

export default function (app) {
    components.forEach(com => app.component(com.name, com));
};